export default function MenuIcon({ label = 'Menu', ...restProps }) {
	return (
		<svg
			version='1.1'
			viewBox='0 0 14 12'
			aria-label={label}
			focusable={false}
			xmlns='http://www.w3.org/2000/svg'
			{...restProps}
		>
			<path
				fill='currentColor'
				fillRule='evenodd'
				d='M1 12h12a1 1 0 100-2H1a1 1 0 100 2m0-5h12a1 1 0 100-2H1a1 1 0 100 2m0-7h12a1 1 0 110 2H1a1 1 0 110-2'
			/>
		</svg>
	);
}
